<template>
  <div class="text-center">
    <v-icon class="mb-2 grey--text text--lighten-3" size="80">
      mdi-alert-circle-outline
    </v-icon>
    <p class="mb-0 grey--text">
      {{ $t('emptyState.noData') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
}
</script>
